
define('text!modules/profiles/cards/templates/role.bin.template.html',[],function () { return '<span class="roleBin"></span>';});

